import { render, staticRenderFns } from "./book.vue?vue&type=template&id=a0babe20&scoped=true&"
import script from "./book.vue?vue&type=script&lang=js&"
export * from "./book.vue?vue&type=script&lang=js&"
import style0 from "./book.vue?vue&type=style&index=0&id=a0babe20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0babe20",
  null
  
)

export default component.exports